import isDefined from './guards/isDefined';
import type { Lucid } from '../types/types';

type Keys = 'main_nav_by_id' | 'footer_by_id';

type GetDirectusMenuQuery = {
  directus: {
    [Key in Keys]?: Key extends 'main_nav_by_id' ? Lucid.Directus.Generated.Main_Nav : Lucid.Directus.Generated.Footer;
  };
};

const getDirectusMenu = (query: GetDirectusMenuQuery, languageKey: Lucid.I18n.LanguagesShortCode) => {
  const queryData = query.directus;

  if (queryData.footer_by_id) {
    const allColumns = (queryData.footer_by_id.columns?.map(column => column.footer_column_id) || []).filter(isDefined);
    const trColumns = allColumns.reduce((result, current) => {
      const trColumn = current?.translations?.find(tr => tr.languages_code?.short_code === languageKey);
      if (trColumn) return [...result, trColumn];

      return result;
    }, [] as Lucid.Directus.Generated.Footer_Column_Translations[]);

    return trColumns;
  }

  if (queryData.main_nav_by_id) {
    // Not sure if this one works yet, but I just copied it from the footer stuff and renamed some variables.
    const allSections = (queryData.main_nav_by_id.sections?.map(section => section.nav_section_id) || []).filter(
      isDefined,
    );
    const trSections = allSections?.reduce((result, current) => {
      const trSection = current?.translations?.find(tr => tr.languages_code?.short_code === languageKey);
      if (trSection) return [...result, trSection];

      return result;
    }, [] as Lucid.Directus.Generated.Nav_Section_Translations[]);

    return trSections;
  }
};

export default getDirectusMenu;
